import Axios from 'axios'
import { URLS } from './constants'

const BASE_URL = `${URLS.URL_PRD_MANIFEST}/stores`

const storesAPI = {

  getStores: async () => {
    const url = `${BASE_URL}`
    const { data } = await Axios.get(url)
    return data.stores
  },
}

export default storesAPI
